<template>
  <v-simple-table>
    <thead>
      <tr>
        <th>No</th>
        <th>Name</th>
        <th>Age</th>
        <th>Sex</th>
        <th>Type</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item,index) in presumptiveData" v-bind:key="item.id">
        <td>{{ index+1 }}</td>
        <td>{{ item.name }}</td>
        <td>{{ item.age }}</td>
        <td>{{ item.sex }}</td>
        <td>{{ item.confirm==0?"Family Member":"Presumptive" }}</td>
        <td>
          <v-btn
            v-if="item.confirm==1"
            @click="goToForm(item)"
            icon
            color="orange darken-1"
            class="mr-2 white--text"
            depressed
          >
            <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("Presumptive", ["presumptiveData"])
  },
  methods: {
    goToForm(item)
    {
      
      if (item.confirm==1)
      this.$router.push(`/presumptive-detail/${item.id}`);
    }
  },
  
};
</script>

<style>
</style>